<template lang="pug">
.B3GisLoadIndicator
  fade-loader.B3GisLoadIndicator-loader(
    :loading='true',
    color='#27bd8a',
    height='8px',
    width='3px',
    radius='10px'
  )
  .B3GisLoadIndicator-text
    | Загрузка геоинформационного модуля
</template>

<script>
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'

export default {
  name: 'B3GisLoadIndicator',

  components: {
    FadeLoader
  }
}
</script>

<style lang="scss">
.B3GisLoadIndicator {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &-loader {
    position: relative;
    height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/B3Gis/B3GisLoadIndicator.vue